<template>
    <div class="pic-wrap">
        <el-row :gutter="20">
            <el-descriptions class="margin-top" border>
                <el-descriptions-item label="规则">优惠券允许领取条件</el-descriptions-item>
            </el-descriptions>
        </el-row>
        <el-row :gutter="20">
            <el-table :data="ruleList" stripe border center :size="GCONFIG.styleTableSize"
                      v-loading="loading">
                <el-table-column type="index" label="序号" width="45"></el-table-column>
                <el-table-column prop="ruleTypeName" label="限定领取类型" width="170">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.ruleType"
                                   filterable
                                   clearable
                                onchange="">
                            <el-option v-for="item in ruleTypeList"
                                       :key="item.value"
                                       :label="item.name"
                                       :value="item.value">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column prop="begin" label="起始区间(包含)" width="180">
                    <template slot-scope="scope">
                        <el-input-number v-model="scope.row.begin" :disabled="scope.row.ruleType!=1"></el-input-number>
                        <spa v-show="scope.row.ruleType==1">单</spa>
                    </template>
                </el-table-column>
                <el-table-column prop="end" label="结束区间(不包含)" width="180">
                    <template slot-scope="scope">
                        <el-input-number v-model="scope.row.end" :disabled="scope.row.ruleType!=1"></el-input-number>
                        <spa v-show="scope.row.ruleType==1">单</spa>
                    </template>
                </el-table-column>
                <el-table-column prop="descText" label="提示文案" width="180">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="领取失败时提示文案" placement="top-start">
                            <el-input v-model="scope.row.descText" placeholder="领取失败时提示文案" clearable></el-input>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right">
                    <template slot="header" slot-scope="scope">
                        操作
                        <el-button type="primary" size="mini" @click="addRule()">添加领取条件</el-button>
                    </template>
                    <template slot-scope="scope">
                        <el-button-group>
                            <el-button type="success" size="mini" @click="saveRule(scope.row)">保存</el-button>
                            <el-button type="danger" v-show="scope.row.ruleId!=null" size="mini"
                                       @click="deleteRule(scope.row.ruleId)">删除

                            </el-button>
                        </el-button-group>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
    </div>
</template>

<script>
    import draggable from 'vuedraggable'
    import {
        deleteCashticketRuleApi,
        saveCashticketRuleApi,
        getCashticketRuleListApi,
        getCashticketRuleTypeListApi,
        deleteCouponConfigApi
    } from '@/api/api'
    import ElRow from "element-ui/packages/row/src/row";
    export default{
        data(){
            return {
                bindCode: this.$route.query.bindCode,
                loading: true,
                ruleTypeList:[],
                ruleList: []
            }
        },
        computed: {},
        components: {
            //picDialog,
            ElRow, draggable
        },
        mounted(){
            this.getRuleTypeList()
            this.getRuleList()
        },
        methods: {
            addRule(){
                this.ruleList.push({
                    ruleType: 1,
                    ruleTypeName: '订单数',
                    begin: 0,
                    end: 1,
                    bindCode: this.bindCode,
                    descText: '不符合领取条件噢'
                })
            },
            getRuleTypeList(){
                getCashticketRuleTypeListApi({}).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.ruleTypeList = res.data.value;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            getRuleList(){
                this.loading = true;
                getCashticketRuleListApi({bindCode: this.bindCode}).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.ruleList = res.data.value;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            deleteRule(ruleId){
                this.loading = true;
                deleteCashticketRuleApi({ruleId: ruleId}).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.getRuleList()
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            saveRule(item){
                this.loading = true;
                saveCashticketRuleApi(item).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.getRuleList()
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            }
        }
    }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
    .pic-wrap {
        padding: 10px;
    }

    .header-return {
        margin-bottom: 20px;
        border-bottom: 1px solid #eeeeee;
        padding-bottom: 10px;
        position: relative;
        h2 {
            text-align: center;
            position: absolute;
            left: 50%;
            top: 0;
            margin: 0;
        }
    }

    .pic-btn-wrap {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 20px;
        p {
            color: #e50011;
            font-size: 20px;
            margin: 0;
        }
    }

    .header-btn {
        margin-left: 20px;
        font-size: 24px;
        font-weight: bold;
        padding: 5px 10px;
    }

    .drag-container {
        width: 100%;
        text-align: center;
        font-size: 14px;
        color: #606266;
        border-spacing: 0;
        border-collapse: collapse;
        img {
            width: 70px;
            height: 70px;
        }
        td, th {
            padding: 12px 0;
            border: 1px solid #EBEEF5;

        }
        th {
            background: #eef1f6;
            color: #222222;
            text-align: center;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/coupon/couponRule.vue